import {KnowledgeServer, PersonServer} from '@/api'
import AthubCloudApi from '@/api/athubCloud'
import { merge } from '@/util'

export default {
  getDepartments({commit}) {
    AthubCloudApi.fetchRunningDeptList().then((deptList) => {
      commit('setDepartments', deptList);
      let deptIds = deptList.map(e => e.id);
      let params = {
        departments: deptIds
      };
      PersonServer.personApi.list(params).then((res) => {
        console.log(`setPersons `, res);
        commit('setPersons', res.data.data);
      })
    });
  },
  getAbstractReportByDepartment({commit}, search) {
    KnowledgeServer.reportApi.getAbstractReportByDepartment(search).then((res) => {
      commit("setAbstractAddCountByDepartment", merge(true, [], res.data.result.sort((a, b) => a.abstractTotal < b.abstractTotal ? -1 : 1)));
      commit("setAbstractClickCountByDepartment", merge(true, [], res.data.result.sort((a, b) => a.clickTotal < b.clickTotal ? -1 : 1)));
      commit("setAbstractHotByDepartment", merge(true, [], res.data.result.sort((a, b) => a.hotTotal < b.hotTotal ? -1 : 1)));
    });
  },
  getAbstractAddCountByDepartment({commit}, search) {
    KnowledgeServer.reportApi.getAbstractAddCountByDepartment(search).then((res) => {
      commit("setAbstractAddCountByDepartment", merge(true, [], res.data.result.sort((a, b) => a.abstractTotal < b.abstractTotal ? -1 : 1)));
    });
  },
  getAbstractClickCountByDepartment({commit}, search) {
    KnowledgeServer.reportApi.getAbstractClickCountByDepartment(search).then((res) => {
      commit("setAbstractClickCountByDepartment", merge(true, [], res.data.result.sort((a, b) => a.clickTotal < b.clickTotal ? -1 : 1)));
    });
  },
  getAbstractHotByDepartment({commit}, search) {
    KnowledgeServer.reportApi.getAbstractHotByDepartment(search).then((res) => {
      commit("setAbstractHotByDepartment", merge(true, [], res.data.result.sort((a, b) => a.hotTotal < b.hotTotal ? -1 : 1)));
    });
  },
  getAbstractAddCountByUser({commit}, search) {
    KnowledgeServer.reportApi.getAbstractAddCountByUser(search).then((res) => {
      commit("setAbstractAddCountByUser", merge(true, [], res.data.result.sort((a, b) => a.abstractTotal < b.abstractTotal ? -1 : 1)));
    });
  },
  getUserClickCount({commit}, search) {
    KnowledgeServer.reportApi.getUserClickCount(search).then((res) => {
      commit("setUserClickCount", merge(true, [], res.data.result.sort((a, b) => a.abstractTotal < b.abstractTotal ? -1 : 1)));
    });
  },
  getAbstractHot({commit}, search) {
    KnowledgeServer.reportApi.getAbstractHot(search).then((res) => {
      commit("setAbstractHot", merge(true, [], res.data.result.sort((a, b) => a.hotTotal < b.hotTotal ? -1 : 1)));
    });
  },
  getWordByQueryCount({commit}, search) {
    KnowledgeServer.reportApi.getWordByQueryCount(search).then((res) => {
      commit("setWordByQueryCount", res.data.result);
    });
  },
  getKeywordByQueryCount({commit}, search) {
    KnowledgeServer.reportApi.getKeywordByQueryCount(search).then((res) => {
      commit("setKeywordByQueryCount", res.data.result);
    });
  }
}